import { StepperOrientation } from '@angular/cdk/stepper';
import { Component, inject, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/env';
import { SppdashboardService } from '../dashboard/sppdashboard.service';
import { employmentTypeList, namewithSpace } from 'src/app/utils/constants';
import { FormBuilder, Validators } from '@angular/forms';
import { BreakpointObserver } from '@angular/cdk/layout';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserDataModalComponent } from 'src/app/component/user-data-modal/user-data-modal.component';
import { HelpdeskService } from '../admin/helpdesk/helpdesk.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from '@pearsonvue/topaz-angular-ui';
import { PreSubmissionModalComponent } from 'src/app/component/pre-submission-modal/pre-submission-modal.component';
import { FTEModalComponent } from 'src/app/component/fte-modal/fte-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reinstate-request',
  standalone: false,
  templateUrl: './reinstate-request.component.html',
  styleUrl: './reinstate-request.component.scss'
})
export class ReinstateRequestComponent implements OnInit {

  icons = {
    faInfoCircle
  }

  stepperOrientation!: Observable<StepperOrientation>;
  reinstatementStepTwo: any;
  reinstatementStepOne: any;
  currentUser: any;
  expiredMoreThanThree: boolean | null = null;

  languageList: any = [];
  countryList: any = [];
  timezoneList: any = [];
  employmentTypeList: any = employmentTypeList;
  isCheckboxSelected: boolean | null = null;
  formSubmitted: boolean = false;
  status: string | null = null;
  public iscpProviderList: any = [];
  public selectediscpProvider: any | null = null;
  public dialogConfig: any = {};
  public simpleDialog!: MatDialogRef<UserDataModalComponent>;
  public dialogRef!: MatDialogRef<PreSubmissionModalComponent>;


  public snackbar = inject(MatSnackBar);
  mctSubscriptionEndDate: string | null = null;
  checkerrOnSubmit: boolean = false;
  public tempObject: any = {};
  userSelectedFlow: string = '';
  public FTEDialog!: MatDialogRef<FTEModalComponent>;
  public isFTEuser: boolean = false;


  constructor(
    private readonly sppdashboardService: SppdashboardService,
    private readonly _fb: FormBuilder,
    breakpointObserver: BreakpointObserver,
    private readonly helpService: HelpdeskService,
    private readonly dialogModel: MatDialog,
    private readonly loaderService: LoaderService,
    private readonly router: Router,
  ) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 600px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
  }

  ngOnInit(): void {
    this.initMctForms();
    this.patchFormData();
    this.getIscpProviderList();
    this.getLanguageList();
    this.getCountryList();

    this.sppdashboardService.getUser().subscribe((res: any) => {
      this.sppdashboardService.getTimeZonesByCountryName(res.data.country).subscribe((response: any) => {
        if (response.success) {
          this.timezoneList = response.data;
        }
      }, (error: any) => {
        console.error("Error fetching Timezone List", error);
      });
    });
  }

  initMctForms(): void {
    this.reinstatementStepOne = this._fb.group({
      firstname: ["", [Validators.required, Validators.pattern(namewithSpace)]],
      lastname: ["", [Validators.required, Validators.pattern(namewithSpace)]],
      email: [{ value: '', disabled: true }],
      language: ["", Validators.required],
      country: ["", Validators.required],
      timezone: ["", Validators.required],
      employmentType: ["", Validators.required],
    });

    this.reinstatementStepTwo = this._fb.group({
      mctAgreement: [{ value: '', disabled: true }, Validators.required],
    });
  }

  patchFormData = () => {
    this.loaderService.showLoader('Loading...');
    this.sppdashboardService.getUser().subscribe((response: any) => {
      if (response.success && response.data) {
        const res = response.data;
        this.status = res.status;
        this.mctSubscriptionEndDate = res.mctSubscriptionEndDate;
        this.sppdashboardService.getStatusForThreeYear(res.email).subscribe(
          (response: any) => {
            this.loaderService.hideLoader();
            this.expiredMoreThanThree = response;
            if (this.expiredMoreThanThree) {
              const dialogRef = this.dialogModel.open(PreSubmissionModalComponent, {
                data: {
                  userstage: 'FTE_USER'
                }
              });
              dialogRef.afterClosed().subscribe((value) => {
                if (value === 'ISCPFlow' || value === 'ILTFlow') {
                  this.userSelectedFlow = value;
                }
              })
            } else {
              this.FTEDialog = this.dialogModel.open(FTEModalComponent, {
                width: '600px',
              });


              this.FTEDialog.afterClosed().subscribe((result) => {  
                  if(result == 'yes'){
                    // take user to ISCP flow
                    this.isFTEuser = true;
                  } 
              });

            }
          }, (error) => {
            this.loaderService.hideLoader();
          });

        this.reinstatementStepOne.patchValue({
          firstname: res.firstname,
          lastname: res.lastname,
          email: res.email,
          language: res.language,
          country: res.country,
          timezone: res.timeZone,
          employmentType: res.employmentType,
        });
      }
    }, (error) => {
      this.loaderService.hideLoader();
    })
  }


  getIscpProviderList = () => {
    this.sppdashboardService.getIscpProviderList('', '').subscribe((response: any) => {
      if (response.success) {
        this.iscpProviderList = response.data.content;
      } else {
        console.log("Error fetching ISCP Provider List");
      }
    }, (error: any) => {
      console.error("Error fetching ISCP Provider List", error);
    });
  }

  onSelectionChange(event: any) {
    if (event.value) {
      this.selectediscpProvider = this.iscpProviderList && this.iscpProviderList.filter((iscp: any) => iscp.code === event.value)[0];
      console.log("#selectediscpProvider", this.selectediscpProvider);
    }
  }

  onCountryChange(event: any) {
    this.sppdashboardService.getTimeZonesByCountryName(event.value).subscribe((response: any) => {
      if (response.success) {
        this.timezoneList = response.data;
      }
    }, (error: any) => {
      console.error("Error fetching Timezone List", error);
    });
  }
  getLanguageList = () => {
    this.sppdashboardService.getLanguageList().subscribe((response: any) => {
      this.languageList = response;
    }, (error: any) => {
      console.error("Error fetching Language List", error);
    });
  }

  getCountryList = () => {
    this.sppdashboardService.getCountryList().subscribe((response: any) => {
      this.countryList = response;
    }, (error: any) => {
      console.error("Error fetching Country List", error);
    });
  }

  getTranscript() {
    const pdfUrl = environment.BASE_URL + `/ptp/api/spp/mct/How_to_access_your_Learn_Transcript/download`;
    window.open(pdfUrl, '_blank');
  }

  next() {
    this.reinstatementStepOne.markAllAsTouched();
    this.reinstatementStepOne.updateValueAndValidity();
  }

  agrementDoc = () => {
    this.reinstatementStepTwo.get('mctAgreement')?.enable();
    const pdfUrl = environment.BASE_URL + `/ptp/api/spp/mct/mct_agreement/download`;
    window.open(pdfUrl, '_blank');
  }

  submitReInstatementForm() {
    this.formSubmitted = true;
    if (this.reinstatementStepTwo.valid && this.reinstatementStepOne.valid && this.isCheckboxSelected) {
      const payload = {
        firstname: this.reinstatementStepOne.value.firstname,
        lastname: this.reinstatementStepOne.value.lastname,
        language: this.reinstatementStepOne.value.language,
        country: this.reinstatementStepOne.value.country,
        timezone: this.reinstatementStepOne.value.timezone,
        employmentType: this.reinstatementStepOne.value.employmentType,
        mctAgreement: this.reinstatementStepTwo.value.mctAgreement,
      }

      if (this.expiredMoreThanThree) {
        const email = this.reinstatementStepOne.getRawValue()?.email;
        this.sppdashboardService.userSubmit(payload, email).subscribe((res: any) => {
          if (res.success) {
            this.showSuccessModal(res);
            this.checkerrOnSubmit = false;
          }
        });
      } else {
        const payloadWithEmail = { ...payload, email: this.reinstatementStepOne.getRawValue()?.email };
        this.sppdashboardService.testOutUser(payloadWithEmail).subscribe((res: any) => {
          if (res.success) {
            this.showSuccessModal(res);
            this.checkerrOnSubmit = false;
          }
        });
      }
    }
  }

  showSuccessModal(res: any) {
    this.sendEmail(res);
    if (res?.data?.status === 'TEST_OUT_OPEN') {

      res.message = `Thank you for submitting your application.<br/>
                    You may now proceed to the MCT Instructional Skills Assessment. 
                    Once payment is completed and the assessment is passed, 
                    you can complete your MCT Program registration and pay your MCT Program Fee.<br/>
                    For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> - we’re here to help!`;
      res.title = 'Your application has been submitted.';

    } else {
      res.message = `Thanks for submitting application <br/><br/> 
                    You may now proceed with the ILT training enrolment by accessing link provided in portal. 
                    Please use the link to complete the required payment, 
                    enroll the Training and Complete the scheduled ILT Trainings.
                    <br/>
                    Once the training is completed, your results will be updated in the portal.
                    For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> - we’re here to help!`;
      res.title = 'Your MCT Reinstatement request has been submitted.';
    }
    this.dialogConfig.value = res
    this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });
  }

  sendEmail(res: any): void {

    if (res?.data?.status === 'TEST_OUT_OPEN') {
      if (this.reinstatementStepOne.getRawValue()?.email) {
        this.tempObject = {
          "recipientEmail": this.reinstatementStepOne.getRawValue()?.email,
          "subject": 'Reinstatement Request Submitted',
          "templateName": 'MCTTestOutSubmittedNew',
          "language": "en",
          "customContext": "{}"
        }
      }

      else {
        if (this.reinstatementStepOne.getRawValue()?.email) {
          this.tempObject = {
            "recipientEmail": this.reinstatementStepOne.getRawValue()?.email,
            "subject": 'Reinstatement Request Submitted',
            "templateName": 'MCTAppReceived',
            "language": "en",
            "customContext": "{}"
          }
        }

      }

      this.helpService.sendEmail(this.tempObject).subscribe((res: any) => {
        if (res.success) {
          /* empty */
        } else {
          this.snackbar.open(res.errors, '', { verticalPosition: 'top', horizontalPosition: 'center' });
        }
      }, (error: any) => {
        const errMsg = error?.error?.errors ? error?.error?.errors : [error?.error?.error];
        errMsg?.map((msg: string) => {
          this.snackbar.open(msg, '', { verticalPosition: 'top', horizontalPosition: 'right', panelClass: ['warning'] });
        });
      })
    }
  }

}
